import React from 'react';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

export const planningSummary = tasks => ({
  processing: tasks.some(task => task.status === 'processing'),
  finished: tasks.filter(task => task.status === 'finished').length,
  failed: tasks.filter(task => task.status === 'canceled').length,
  total: tasks.length
});

export const elapsedPlanningTime = (task, clock = Date.now()) => {
  const start = Date.parse(task.started_at || task.created);
  const end = task.completed_at ? Date.parse(task.completed_at) : clock;
  const seconds = Number.isFinite(start) && Number.isFinite(end) ? Math.max(0, Math.floor((end - start) / 1000)) : 0;
  return String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
};

export default function PlanningProgress({ tasks, res, statusError, onRetry, retryDisabled }) {
  if (!tasks.length && !statusError) return null;
  const summary = planningSummary(tasks);
  if (summary.total > 0 && summary.finished === summary.total) return null;
  return (
    <section aria-label={res.OS_PLANNING_TITLE} style={{ margin: '0 0 16px', padding: 16, border: '1px solid #d9dce3', borderRadius: 6 }}>
      <div aria-live="polite">
        <strong>{res.OS_PLANNING_TITLE}</strong>
        <div>{res.OS_PLANNING_SAVED}</div>
        {!!summary.total && <div>{res.OS_PLANNING_SUMMARY.replace('{finished}', summary.finished).replace('{total}', summary.total)}</div>}
        {statusError && <div role="status" style={{ color: '#9b6200' }}>{res.OS_PLANNING_CONNECTION_ERROR}</div>}
        {tasks.map((task, index) => {
          const phase = task.status === 'canceled' ? 'FAILED' : task.status === 'finished' ? 'FINISHED' : String(task.phase || 'queued').toUpperCase();
          const heartbeat = Date.parse(task.heartbeat_at || task.started_at || task.created);
          const noUpdate = task.status === 'processing' && Number.isFinite(heartbeat) && Date.now() - heartbeat > 60000;
          return (
            <div key={task.id_task} style={{ paddingTop: 12 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {task.status === 'processing' && <CircularProgress size={16} />}
                <span>{res.OS_PLANNING_JOB.replace('{number}', index + 1)}: {res['OS_PLANNING_PHASE_' + phase]}</span>
                <span style={{ color: '#666' }}>{elapsedPlanningTime(task)}</span>
              </div>
              {noUpdate && <div style={{ color: '#9b6200' }}>{res.OS_PLANNING_NO_UPDATE}</div>}
              {task.error && <div role="alert" style={{ color: '#b3261e' }}>{res[task.error.code] || res.OS_PLANNING_FAILED}</div>}
            </div>
          );
        })}
      </div>
      {!!summary.failed && <Button onClick={onRetry} disabled={retryDisabled || summary.processing} style={{ marginTop: 12 }}>
        {res.OS_PLANNING_SAVE_RETRY}
      </Button>}
    </section>
  );
}
